export function onLoad (cb) {
  let loaded = false

  if (document.readyState && document.readyState === 'complete') {
    loaded = true
    cb()
    return
  }

  document.addEventListener('DOMContentLoaded', e => {
    if (loaded !== true) {
      loaded = true
      cb()
    }
  })

  window.onload = () => {
    if (loaded !== true) {
      loaded = true
      cb()
    }
  }
}
